import { createStyles, makeStyles } from '@material-ui/core/styles';

import { APP_BAR_DESKTOP_HEIGHT, APP_BAR_HEIGHT } from '../../constants';

export const useStyles = makeStyles(({ breakpoints, spacing }) =>
  createStyles({
    root: {
      display: 'block',
      width: '40.1px', // real value should be 'auto' // TODO: logo and logo mark svg need to be pixel perfected
      height: APP_BAR_HEIGHT - spacing(4),

      [breakpoints.up('lg')]: {
        height: APP_BAR_DESKTOP_HEIGHT - spacing(6),
      },
    },
  })
);
